import {
  QUOTE_LINE_INFO_TABS,
  QUOTE_PRICE_FIELDS,
  QUOTE_PRICE_STRATEGY_BADGE_COLORS,
} from '../constants';
import { PriceStrategyUIConfigEntry } from '../types';

export const newPartUserCostUIConfig: PriceStrategyUIConfigEntry = {
  badge: {
    color: QUOTE_PRICE_STRATEGY_BADGE_COLORS.USER,
    label: 'New Part',
  },
  partDetailsExtraComponents: [],
  fields: [
    {
      field: QUOTE_PRICE_FIELDS.quantity,
      editable: true,
    },
    {
      field: QUOTE_PRICE_FIELDS.unitCost,
      editable: true,
    },
    {
      field: QUOTE_PRICE_FIELDS.unitPrice,
      editable: true,
    },
    {
      field: QUOTE_PRICE_FIELDS.grossMargin,
      editable: true,
    },
    {
      field: QUOTE_PRICE_FIELDS.leadTimeWeeks,
      editable: true,
    },
  ],
  tabs: [QUOTE_LINE_INFO_TABS.COST_BREAKS],
} as const;
